import React, { useState, Suspense } from 'react'
import Header from '../../pages/Header/Header' // مسیر را طبق پروژه خودتان چک کنید
import Footer from '../../pages/Footer/Footer' // مسیر را طبق پروژه خودتان چک کنید
import './Layout.css';

// تعریف به صورت Lazy
const Register = React.lazy(() => import('../../pages/Buyer/Register/Register'));

// اضافه شدن پراپ hideHeader با مقدار پیش‌فرض false
const Layout = ({ children, hideHeader = false, hideNotification = false }) => {
    const [isShowRegister, setIsShowRegister] = useState(false)
    const fn_showRegister = () => {
        setIsShowRegister(!isShowRegister)
    }

    return (
        <>
            {/* اضافه شدن کلاس شرطی no-header */}
            <div className={`layout-wrapper ${hideHeader ? 'no-header' : ''}`}>

                {/* نمایش شرطی هدر اصلی */}
                {!hideHeader && (
                    <div className='layout-header'>
                        <Header fn_showRegister={fn_showRegister} hideNotification={hideNotification} />
                    </div>
                )}

                <div className='layout-content'>
                    {children && children}
                </div>

                <div className='layout-footer'>
                    <Footer />
                </div>

            </div>

            {/* استفاده از Suspense برای لود ناهمگام */}
            <Suspense fallback={null}>
                {isShowRegister && (
                    <Register fn_close={fn_showRegister} isShow={isShowRegister} />
                )}
            </Suspense>
        </>
    )
}

export default Layout
